import { createSelector } from 'reselect';

const getRatingState: (state: any) => any = state => state?.ratings || {};

const getFeedBackQuestions = createSelector(
  getRatingState,
  ratingData => ratingData?.userGivenRating?.questionResponse?.questions || []
);

const getUserRatingData = createSelector(
  getRatingState,
  ratingData => ratingData?.userGivenRating?.userRating || {}
);

const getEditFeedBackQuestions = createSelector(
  getRatingState,
  ratingData => ratingData?.questions?.questions || []
);

const getFeedBackPendingProducts = createSelector(
  getRatingState,
  ratingData => ratingData?.unRatedProducts?.userUnratedItems || []
);

const getUnratedItems = createSelector(
  getRatingState,
  ratingData => ratingData?.unRatedProducts || []
);

export {
  getRatingState,
  getFeedBackQuestions,
  getFeedBackPendingProducts,
  getEditFeedBackQuestions,
  getUserRatingData,
  getUnratedItems
};
